"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceVersion = void 0;
/**
 * A type of a manufactured item that is used in the provision of healthcare without being substantially changed through that activity. The device may be a medical or non-medical device.
 */
var DeviceVersion = /** @class */ (function () {
    function DeviceVersion() {
    }
    return DeviceVersion;
}());
exports.DeviceVersion = DeviceVersion;
